//Нарезает массив на несколько массивов по переданному количеству элементов
export const chunkArray = <T>(array: Array<T>, chunk: number): Array<T>[] => {
    const newArray = [];
    for (let i = 0; i < array.length; i += chunk) {
        newArray.push(array.slice(i, i + chunk));
    }
    return newArray;
};
